import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Check if we have a scrollToCart parameter - if so, don't scroll to top
    const params = new URLSearchParams(search);
    const shouldScrollToCart = params.get('scrollToCart');
    
    // Only scroll to top if we're not supposed to scroll to cart
    if (shouldScrollToCart !== 'true') {
      window.scrollTo(0, 0);
    }
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
